import { IconButton } from "@mui/material";

export type DrawerProps = {
  open: boolean;
  handleClose: () => void;
};
type DrawerButtonProps<ExtraDrawerProps extends object = object> = DrawerProps & {
  handleOpen: () => void;
  Icon: JSX.Element;
  Drawer: React.ComponentType<DrawerProps & ExtraDrawerProps>;
  drawerProps?: ExtraDrawerProps;
};
export default function DrawerButton({
  handleClose,
  handleOpen,
  Icon,
  open,
  Drawer,
  drawerProps,
}: DrawerButtonProps) {
  return (
    <>
      <IconButton onClick={() => (open ? handleClose() : handleOpen())}>
        {Icon}
      </IconButton>
      <Drawer open={open} handleClose={handleClose} {...drawerProps} />
    </>
  );
}
